/* eslint-disable no-restricted-globals */
// ─────────────────────────────────────────────────────────────────────────
// SERGA // PERSONAL OS — tiny DOM + math helpers shared across HUD modules.
// Previously copy-pasted into hud.js / tray.js / sonic.js (el, $, on) and
// world.js / spotify.js (clamp). Centralised here so there's one definition.
// ─────────────────────────────────────────────────────────────────────────

// querySelector shorthand (document- or element-scoped)
export const $ = (s, r = document) => r.querySelector(s);

// create an element with an optional class + innerHTML
export const el = (tag, cls, html) => {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (html != null) e.innerHTML = html;
  return e;
};

// clamp a number to [a, b]
export const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

// A self-tracking addEventListener. `on(target, type, fn)` registers a listener
// and remembers it so dispose() can remove every one — the HUD/rails use this to
// tear down cleanly under React StrictMode's double-mount.
export function trackedListeners() {
  const tracked = [];
  const on = (target, type, fn, opts) => { target.addEventListener(type, fn, opts); tracked.push([target, type, fn, opts]); };
  const dispose = () => { tracked.forEach(([t, ty, fn, o]) => t.removeEventListener(ty, fn, o)); tracked.length = 0; };
  return { on, dispose };
}
